import { createSelector } from "@ngrx/store";
import { selectFeature } from './_base'
import { calculateRoomGrossRentalIncome, calculation as calc } from "../core/income/hotel";

export const hotelIncomeState = createSelector(
    selectFeature,
    (state) => {
        if (state.valuationProcess.kind === 'unknown') return null;
        if (state.valuationProcess.kind === 'market') return null;
        return {
            foodBeverageRevenue: state.valuationProcess.data.foodBeverageRevenue,
            otherRevenue: state.valuationProcess.data.otherRevenue,
            rooms: state.valuationProcess.data.rooms,
            opex: state.valuationProcess.data.opex,
            capitalRate: state.valuationProcess.data.capitalRate,
            fbCost: state.valuationProcess.data.fbCost,
            purchaserCost: state.valuationProcess.data.purchaserCost,
            opexChoiceId: state.valuationProcess.data.opexChoiceId,
            fbChoiceId: state.valuationProcess.data.fbChoiceId,
            timingId: state.valuationProcess.data.timingId,
            costs: state.valuationProcess.data.costs
        }
    }
)

export const rooms = createSelector(
    hotelIncomeState,
    (state) => {
        if (!state) return []
        return state.rooms
    }
) 

export const foodBeverageRevenue = createSelector(
    hotelIncomeState,
    (state) => state ? state.foodBeverageRevenue : null
)

export const otherRevenue = createSelector(
    hotelIncomeState,
    (state) => state ? state.otherRevenue : null
)

export const costs = createSelector(
    hotelIncomeState,
    (state) => state ? state.costs : []
)

export const calculatedRooms = createSelector(
    rooms,
    (rooms) => {
        return rooms.map(calculateRoomGrossRentalIncome)
    }
)

export const totalRooms = createSelector(
    calculatedRooms,
    (rooms) => {
        return rooms.reduce((acc, room) => {
            return room.no ? acc + room.no : acc
        }, 0)
    }
)

export const totalRoomsGrossRentalIncome = createSelector(
    calculatedRooms,
    (rooms) => {
        return rooms.reduce((acc, room) => {
            return room.gross_rental_income ? acc + room.gross_rental_income : acc
        }, 0)
    }
)

export const foodBeverageGrossRentalIncome = createSelector(
    totalRoomsGrossRentalIncome,
    foodBeverageRevenue,
    (total, revenue) => {
        const percent = revenue ? (revenue/100) : 0
        return total * percent
    }
)

export const otherGrossRentalIncome = createSelector(
    totalRoomsGrossRentalIncome,
    otherRevenue,
    (total, revenue) => {
        const percent = revenue ? (revenue/100) : 0
        return total * percent
    }
)

export const grossRentalIncome = createSelector(
    totalRoomsGrossRentalIncome,
    foodBeverageGrossRentalIncome,
    otherGrossRentalIncome,
    (total, food, other) => total + food + other
)

const gri = createSelector(
    totalRoomsGrossRentalIncome,
    foodBeverageGrossRentalIncome,
    otherGrossRentalIncome,
    grossRentalIncome,
    (rooms, food, other, total) => ({rooms, food, other, total})
)

export const calculation = createSelector(
    hotelIncomeState,
    gri,
    (state, gri) => {
        if (!state) return null;
        return calc({
            capitalRate: state.capitalRate,
            gri: gri,
            opex: {
                percent: state.opex,
                choiceId: state.opexChoiceId,
            },
            fb: {
                percent: state.fbCost,
                choiceId: state.fbChoiceId
            },
            costs: state.costs,
            purchaserCost: state.purchaserCost,
            timingId: state.timingId
        })
    }
)